// extracted by mini-css-extract-plugin
module.exports = {"clearcart__mobile":"ModalOptionsMobile_clearcart__mobile__yjsCO"};